import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';

import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { registerLocaleData } from '@angular/common';
import { register } from 'swiper/element/bundle';

enableProdMode();
register();
export declare const BackgroundGeolocation: any;

platformBrowserDynamic().bootstrapModule(AppModule);

registerLocaleData(localeDe, 'de', localeDeExtra);
